import React from "react";
import { TableCell, TableRow } from "@mui/material";
import UsersTableRow from "./UsersTableRow";
import EntityListTable from "../../helpers/EntityListTable";

const UsersTable = ({
  usersList,
  currentPage,
  onPageButtonClicked,
}) => {
  const displayedUsers = usersList.slice(0, 10);
  const hasNextPage = usersList.length === 11;

  return (
    <EntityListTable
      currentPage={currentPage}
      hasNextPage={hasNextPage}
      onPageButtonClicked={onPageButtonClicked}
      tableHeaderComponent={
        <TableRow>
          <TableCell>Last Name</TableCell>
          <TableCell align="right">First Name</TableCell>
          <TableCell align="right">Create Date</TableCell>
          <TableCell align="right">Last Modified</TableCell>
        </TableRow>
      }
    >
      {displayedUsers.map(
        (user) => <UsersTableRow
          key={user.userEntityId}
          user={user}
        />,
      )}
    </EntityListTable>
  );
};

export default UsersTable;
